export function width(element) {
    return element.getBoundingClientRect().width;
}

export function get_coords(event) {
    if (window.TouchEvent && event instanceof window.TouchEvent) {
        const { clientX, clientY } = event.touches[0];
        return {
            x: clientX,
            y: clientY,
        };
    }

    const { x, y } = event;

    return { x, y };
}

export function minimapScroll({
    moving,
    lastCoords,
    element,
    event,
    forMap,
    setLastCoords,
}) {
    if (!moving || !element) {
        return null;
    }

    const { x } = get_coords(event);

    // For now only scroll horizontally
    let delta = x - lastCoords.x;
    let newLeft = (parseInt(element.style.left) || 0) + delta;
    if (newLeft < 0) {
        newLeft = 0;
    }

    // Check end corner
    let parentContainer = document.querySelector(`.throne-minimap.for-${forMap}`);
    if (parentContainer) {
        let ownWidth = width(element);
        let maxWidth = width(parentContainer);
        if (newLeft > maxWidth - ownWidth) {
            newLeft = maxWidth - ownWidth;
        }
    }

    element.style.left = `${newLeft}px`;
    setLastCoords((prevLastCoords) => ({ ...prevLastCoords, x }));
    return newLeft;
}
